<template>
	<transition name="quick-slide">
		<section
			class="ly_quicknav"
			v-show="visible"
			:class="{
				show: visible,
				gapPadding: viewport != defaultWindowHeight,
			}"
		>
			<nav>
				<button type="button" class="btn btn_category" @click="$emit('menuButtonClick')">
					<span class="txt">전체메뉴</span>
				</button>
				<router-link :to="'/specialprice'" class="btn btn_bizspecial" data-tag-index="Menu" data-tag-cate="비즈특가">
					<span class="txt">비즈특가</span>
				</router-link>
				<router-link :to="'/home'" class="btn btn_home" data-tag-index="Menu" data-tag-cate="홈">
					<span class="txt">홈</span>
				</router-link>
				<router-link :to="'/estimate/list'" class="btn btn_estimate" data-tag-index="Menu" data-tag-cate="온라인견적서">
					<span class="txt">온라인견적서</span>
				</router-link>
				<router-link :to="'/mybiz/bizmain'" class="btn btn_mybiz" data-tag-index="Menu" data-tag-cate="마이비즈">
					<span class="txt">마이비즈</span>
					<i v-if="isLoggedIn" class="member_level">
						<!-- api에서 오는 값을 노출. gold/vip/plat/spec-->
						<img :src="userInfo.companyLevelImageUrlOn" :alt="`${levelText} Icon`" />
						<span class="txt_hidden">{{ levelText }}</span>
					</i>
				</router-link>
			</nav>
			<span v-if="!isLoggedIn" class="tooltip mybiz">가입하면 최대 <strong>12% 할인</strong></span>
		</section>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex';

let beforeScrollY = window.pageYOffset;

export default {
	data() {
		return {
			visible: true,
			viewport: 0,
			defaultWindowHeight: 0,
		};
	},
	computed: {
		...mapGetters(['isLoggedIn', 'userInfo']),

		/** 회원등급 */
		levelText() {
			return this.userInfo.companyLevelCd;
		},

		/**
		 * 회원등급 html class명
		 * @return {'spec' | 'gold' | 'vip' | 'plat'} gold: 골드, vip: vip, plat: 플래티넘, spec: Special
		 */

		/**
		 * 스페셜 등급 여부
		 * @description
		 * 'GOLD', 'VIP', 'PLATINUM' 등급이 아닌 경우 스페셜
		 */
		isSpecialLevel() {
			if (!this.userInfo.companyLevelCd) return false;
			return !/^(GOLD|VIP|PLATINUM)$/i.test(this.userInfo?.companyLevelCd);
		},
	},
	methods: {
		scroll(e) {
			const currentScrollY = window.pageYOffset;
			if (document.getElementById('app').clientHeight <= currentScrollY + window.innerHeight && currentScrollY != 0) {
				this.visible = false;
			} else {
				if (currentScrollY === 0) {
					this.visible = true;
					beforeScrollY = currentScrollY;
				} else if (currentScrollY > 30) {
					if (beforeScrollY > currentScrollY) {
						this.visible = true;
						beforeScrollY = currentScrollY;
					} else if (beforeScrollY + 100 < currentScrollY) {
						this.visible = false;
						beforeScrollY = currentScrollY;
					}
				}
			}
			// beforeScrollY = currentScrollY;
		},

		resize() {
			const viewportHeight = window.innerHeight; // viewport 높이
			const defaultWindowHeight = document.body.clientHeight; //body의 높이
			this.viewport = viewportHeight;
			this.defaultWindowHeight = defaultWindowHeight;
		},
	},
	created() {
		window.addEventListener('scroll', this.scroll, false);

		if (document.body.classList.contains('is_safari')) {
			window.addEventListener('resize', this.resize, false);
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.scroll, false);

		if (document.body.classList.contains('is_safari')) {
			window.removeEventListener('resize', this.resize, false);
		}
	},
};
</script>
